<template>
  <div class="ancestor">
    <div class="theme-titles">
      <div class="theme-text">
        <img src='~assets/image/palletimg/heSolution.png' />
        <span class="theme-name">硬件设备</span>
        <span class="boult">&gt;</span>
      </div>
    </div>
    <div class="content">
      <ul>
        <li v-for="(item,index) in solutionList" :key="index">
          <h3>{{item.title}}</h3>
          <p @click="showProduct(index)">了解更多</p>
          <img :src="item.img" />
        </li>
      </ul>
    </div>
    <div class="pop">
      <ul>
        <transition-group>
          <li v-for="(item,index) in productList" :key="index" v-show="Isindex === index">
            <div>
              <div :style="{'margin-top':(index ===5 ? '80px':'')}">
                <img :src="item.imgUrl" />
              </div>
              <h3>产品概述：</h3>
              <p>{{item.overview}}</p>
              <h3 v-if="item.trait">产品特点：</h3>
              <p v-for="(product,index) in item.trait" :key="index">{{product.trait1}}</p>
              <h3>产品应用：</h3>
              <p>{{item.use1}}</p>
            </div>
          </li>
        </transition-group>
      </ul>
    </div>
    <transition name="mask">
      <div class="mask" v-if="isShow" @click="reveal"></div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      solutionList: [
        {
          title: "REID标签",
          img: require("assets/image/solution-img/sol2.png"),
        },
        {
          title: "一体式读写器",
          img: require("assets/image/solution-img/sol7.png"),
        },
        {
          title: "四通道读写器",
          img: require("assets/image/solution-img/sol5.png"),
        },
        {
          title: "八通道读写器",
          img: require("assets/image/solution-img/sol1.png"),
        },
        {
          title: "手持RFID读写设备",
          img: require("assets/image/solution-img/sol4.png"),
        },
        {
          title: "工业平板",
          img: require("assets/image/solution-img/sol3.png"),
        },
        {
          title: "圆极化天线",
          img: require("assets/image/solution-img/sol8.png"),
        },
        {
          title: "线极化天线",
          img: require("assets/image/solution-img/sol6.png"),
        },
      ],
      productList: [
        {
          imgUrl: require("assets/image/solution-img/sol2.png"),
          overview:
            "高性能的无源超高频RFID电子标签，支持ISO 18000-6C标准。标签具有大容量存储器，方便用户建立管理信息。",
          trait: [
            {
              trait1:
                "穿透性较强，抗恶劣环境;安全性、保密性强;可重复使用，数据的记忆容量大。",
            },
            {
              trait1: "可应用于提高生产效率、管理效率等",
            },
          ],

          use1: "托盘管理可直接将标签粘贴于托盘表面，标签较薄，安装后基本不影响物体原有尺寸，标签内部写入托盘相关信息。在出入库等物流管理过程中可跟踪托盘状态，提高物流管理效率。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol7.png"),
          overview:
            "集成天线、读写器为一体的高性能超高频RFID读写器设备。适应用于全工作频段，具有读取距离远、速度快、多标签识别能力超强、抗干扰能力强等优势。",
          trait: [
            {
              trait1:
                "支持密集型读写、支持天线驻波检测功能、支持固件在线升级、支持标签 数据过滤、支持RSSI：可感知信号的强度",
            },
          ],

          use1: "可广泛应用于仓储管理、供应链管理、资产管理、商业零售和自动车辆识别等众多领域。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol5.png"),
          overview:
            "系统集成度相对较低、中小型区域应用，搭配有专用UHF RFID R2000芯片，以及1.6GHz四核处理器，产品性价比高，部署灵活，能够大幅地提升整个场景运作的效率，实现区域的自动化管理，有效降低企业的运营成本。",
          trait: [
            {
              trait1:
                "支持密集型读写、支持天线驻波检测功能、支持固件在线升级、支持标签 数据过滤、支持RSSI：可感知信号的强度、支持POE供电",
            },
          ],

          use1: "广泛应用于车辆稽查、海关通关、车辆查验、人员进出、资产出入、电子门票、档案管理、珠宝管理、仓储进出等场景。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol1.png"),
          overview:
            "八端口超高频RFID固定式读写器，搭配有R2000专用UHF RFID芯片，以及1.6GHz四核处理器，适用于多种复杂应用环境。全面支持EPC C1G2、ISO18000-6B/C、GB/T29768-2013（可选配）等主流UHF RFID空中接口协议，工作频段支持国标双频和FCC，以及ETSI。",
          trait: [
            {
              trait1:
                "支持密集型读写、支持天线驻波检测功能、支持固件在线升级、支持标签数 据过滤、支持RSSI：可感知信号的强度、支持POE供电",
            },
          ],

          use1: "可广泛应用于制造及供应链管理、数字化仓储管理、商业零售、门禁管理、资产管理、智能交通等领域。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol4.png"),
          overview:
            "超高频智能手持终端，融合了UHF超高频读写功能，具备出色的远距离超高频特种识读能力，手握体验感舒适，轻便小巧。",
          trait: [
            {
              trait1:
                "高性能UHF读写模块，结合天线设计，使精确的数据采集距离最远可达5M以上，标签识速率≥200张/5秒，可快速识别高密度密集标签。",
            },
          ],

          use1: "1.可广泛应用于制造及供应链管理、数字化仓储管理、商业零售、门禁管理、资产管理等领域。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol3.png"),
          overview:
            "一款低功耗、高可靠、带触摸的安卓工业平板电脑，具有丰富的I/O接口，采用无风扇、超薄设计，预装有Android 4.2系统。",
          use1: "可应用于楼宇自动化、智能交通系统、车载控制、仓储物流等。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol8.png"),
          overview:
            "一款采用了圆极化极化方式的高性能天线产品，拥有广阔而周密的电磁波辐射面，可实现宽而远的读取距离，最远可达12米。无论是广阔的户外环境，还是复杂的室内环境，远近都可快速读取，灵敏性好，抗干扰性强。",
          trait: [
            {
              trait1: "采用圆极化方式，驻波比小，增益高，识别角度大 ",
            },
          ],

          use1: "可应用于门禁、仓储、物流、零售等各种RFID应用场合中，该天线正逐渐成为远距离RFID项目应用不可或缺的优秀产品。",
        },
        {
          imgUrl: require("assets/image/solution-img/sol6.png"),
          overview:
            "适应户外及室内远距离读取需要的高性能天线，有效弥补圆极化天线在读取距离上面的不足，具有良好的方向性，在进行RFID应用的时候可获得更大可感应空间，从而提高项目应用的可行性。",
          trait: [
            {
              trait1: "定向性、窄波束、高增益，小型化 ",
            },
          ],

          use1: "可应用于车辆管理、畜牧管理、物流管理、新零售、仓库管理等RFID管理系统中。",
        },
      ],
      Isindex: "",
      isShow: false,
    };
  },
  methods: {
    showProduct(index) {
      this.Isindex = index;
      this.isShow = !this.isShow;
    },
    reveal() {
      this.Isindex = null;
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="less" scoped>
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translate(50px, 300px);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.2s linear;
}
.v-leave-active {
  transform: scale(0.2);
}
.ancestor {
  background: #fff;
  width: 100%;
  margin-top: 30px;
  padding-bottom: 30px;
  .theme-titles {
    height: 55px;
    padding: 10px 30px;
    background: #fff;
    border-bottom: 5px solid #ff6000;
    font-size: 16px;
    .theme-text {
      float: left;
      width: 200px;
      > img {
        vertical-align: middle;
      }
      .boult {
        margin-left: 5px;
        font-weight: bold;
        color: #ff6000;
      }
      .theme-name {
        font-weight: bold;
        display: inline-block;
        // margin-top: 6px;
        margin-left: 12px;
      }
    }
  }
  .content {
    //   margin-top: 80px;
    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
    ul li {
      width: 350px;
      height: 350px;
      background: #f2f3f5;
      margin-top: 30px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 20px 20px -20px #5e5e5e;

      h3 {
        //   margin-top: -100px;
        font-size: 28px;
      }
      p {
        width: 150px;
        height: 25px;
        border: 1px solid #ff6000;
        border-radius: 15px;
        margin: 30px 0 30px 0;
        line-height: 25px;
        cursor: pointer;
      }
      img {
        height: 100px;
      }
    }
  }

  .pop {
    ul {
      list-style: none;
      li {
        width: 500px;
        height: 445px;
        background: #fff;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -250px;
        margin-left: -130px;
        z-index: 10;
        border-radius: 5px;
        div {
          margin: 10px;
          > div {
            text-align: center;
            margin-top: 5px;
            img {
              height: 100px;
            }
          }
          h3,
          p {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .mask-enter,
  .mask-leave-to {
    opacity: 0;
    transition: all 0.5s linear;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9;
  }
}
</style>